var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPipette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bold",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.295 9.01c-.256 0-.512-.098-.707-.293-.391-.391-.391-1.024 0-1.414l2.97-2.97c.017-.02.035-.039.054-.058.25-.251.388-.584.388-.938 0-.732-.596-1.327-1.327-1.327-.354 0-.688.138-.938.389-.018.018-.036.035-.055.051l-2.973 2.972c-.391.391-1.023.391-1.414 0s-.391-1.023 0-1.414l3.025-3.025c.021-.021.043-.042.065-.061.621-.589 1.431-.912 2.289-.912 1.836 0 3.328 1.492 3.328 3.327 0 .857-.322 1.666-.909 2.286-.021.023-.041.047-.064.069l-3.025 3.025c-.195.195-.451.293-.707.293z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.293 9.707-5-5c-.391-.391-.391-1.023 0-1.414s1.023-.391 1.414 0l5 5c.391.391.391 1.023 0 1.414s-1.023.391-1.414 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m4 24c-1.103 0-2-.942-2-2.1 0-.838.934-2.724 1.335-3.496.258-.496 1.072-.496 1.33 0 .401.772 1.335 2.658 1.335 3.496 0 1.158-.897 2.1-2 2.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m17.09 7.03c-.293-.293-.768-.293-1.061 0l-3.48 3.48c-.017-.001-.032-.01-.05-.01h-2.059l4.53-4.53c.293-.293.293-.768 0-1.061s-.768-.293-1.061 0l-7.08 7.08c-.448.448-.81.999-1.045 1.588l-.688 1.695c-.193.468-.088 1.002.271 1.36.359.359.893.464 1.355.272l1.695-.688c.595-.238 1.146-.6 1.593-1.046l7.079-7.08c.294-.293.294-.767.001-1.06z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipette);
export default __webpack_public_path__ + "static/media/pipette.c758f6c3035d8ace82b347ec8e9e0a0b.svg";
export { ForwardRef as ReactComponent };